module.exports = __webpack_public_path__ + "img/two-teachers.54287b4f.png";